<template>
  <div v-if="policyPrepare" >
    <div class="d-flex justify-content-between align-items-center pt-50 mb-2">
      <h2 class="font-weight-bolder m-0">
        Política de registro horario
      </h2>
    </div>
    <b-card>
      <!-- form -->
      <validation-observer ref="editPolicy">
        <b-form
            class="mt-2"
            @submit.prevent="handleSubmit"
            @keydown.enter="handleSubmit"
        >
          <!-- Sección Imagen/Avatar -->
          <p class="mb-1">Archivo</p>
          <b-row>
            <b-col cols="12" class="mb-2">
              <FileDropzone ref="files" :files="files" label="Cargar archivo" />
            </b-col>
            <b-col cols="12">
              <validation-provider
                  #default="{ errors }"
                  :name="'Contenido'"
                  rules="required"
              >
                <b-form-group
                    :label="'Contenido'"
                    label-for="task-motivo"
                >
                  <simple-html-editor v-model="content" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <div class="text-right">
            <b-button
                type="submit"
                variant="primary"
                class="mt-2 mr-1"
            >
              {{ 'Guardar' }}
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import {
  BButton, BForm, BFormGroup, BRow, BCol, BCard,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import FileDropzone from '@/components/elements/FileDropzone/FileDropzone.vue'
import SimpleHtmlEditor from '@/components/elements/SimpleHtmlEditor/SimpleHtmlEditor.vue'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    FileDropzone,
    ValidationProvider,
    ValidationObserver,
    SimpleHtmlEditor,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      policyPrepare: false,
      content: '',
      files: [],
      profileFile: null,
    }
  },
  computed: {
    ...mapGetters({
      policy: 'config/getPolicy',
      currentClient: 'clients/getCurrentClient'
    }),
  },
  methods: {
    ...mapActions({
      edit: 'config/editPolicy',
      getPolicy: 'config/getPolicy'
    }),
    ...mapMutations({
      setSelectDepartments: 'departments/setSelectDepartments',
    }),
    setData() {
      if (this.policy.files_policy !== undefined && this.policy.files_policy !== null && this.policy.files_policy) {
        const files = []
        this.policy.files_policy.forEach(element => {
          const file = {
            name: element.name,
            path: element.path,
            urlDelete: '',
          }
          files.push(file)
        })
        this.files = files
      }
      this.content = this.policy.content_policy || ''
      this.policyPrepare = true
    },
    handleSubmit() {
      this.$refs.editPolicy.validate().then(success => {
        if (success) {
          const formData = this.createFormData()
          if (formData) {
            this.edit(formData)
          }
        }
      })
    },
    createFormData() {
      const data = this.$refs.files.getFormData('files_policy')
      data.append('content_policy', this.content)
      data.append('client_id', this.currentClient.id)

      return data
    },
  },
  async created() {
    await this.getPolicy(this.currentClient.id)
    await this.setData()
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
